import { useEffect, useState } from "react"
import PlatformAuth from "aldoo-ra/PlatformAuth"

/**
 * PlatformAuth credentials for SSR-rendered pages: `undefined` during the
 * server render and the first client render (so the markup matches), then
 * the stored credentials (null for guests). `ready` flips after mount.
 */
export default function useClientAuth() {
  const [auth, setAuth] = PlatformAuth.useAuth()
  const [ready, setReady] = useState(false)
  useEffect(() => setReady(true), [])
  return { auth: ready ? auth : undefined, ready, setAuth }
}
